import { useEffect, useRef, useState } from "react";
import { BookOpen, Upload, CheckCircle2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";

export default function BookFilesAdmin() {
  const [books, setBooks] = useState(null); const [busy, setBusy] = useState(""); const ref = useRef(null); const target = useRef("");
  const load = () => api.get("/admin/shop/books").then((r) => setBooks(r.data)).catch(() => setBooks([]));
  useEffect(() => { load(); }, []);
  const pick = (slug) => { target.current = slug; ref.current?.click(); };
  const upload = async (e) => {
    const f = e.target.files?.[0]; e.target.value = ""; if (!f) return;
    const slug = target.current; setBusy(slug);
    const fd = new FormData(); fd.append("file", f);
    try { await api.post(`/admin/shop/books/${slug}/file`, fd, { headers: { "Content-Type": "multipart/form-data" } }); toast.success("Booklet PDF uploaded"); load(); }
    catch (err) { toast.error(err?.response?.data?.detail || "Upload failed"); } finally { setBusy(""); }
  };
  return (
    <div data-testid="book-files-admin">
      <p className="font-mono text-xs tracking-widest uppercase text-slate-400 mb-2 flex items-center gap-1.5"><BookOpen className="w-3.5 h-3.5" />Digital books · PDF files</p>
      <input ref={ref} type="file" accept="application/pdf" className="hidden" onChange={upload} data-testid="book-file-input" />
      <div className="rounded-2xl border border-slate-800 bg-[#131722] divide-y divide-slate-800/60">
        {books?.map((b) => (
          <div key={b.slug} className="flex items-center gap-3 px-4 py-2.5 text-sm" data-testid={`book-row-${b.slug}`}>
            <img src={`/shop/books/${b.slug}-cover.jpg`} alt="" className="w-8 h-12 rounded object-cover" />
            <div className="flex-1 min-w-0"><p className="font-semibold truncate">{String(b.n).padStart(2, "0")} · {b.title}</p><p className="text-[11px] text-slate-500 truncate">{b.file ? `${b.file.filename} · ${(b.file.size / 1048576).toFixed(1)} MB · ${b.file.uploaded_at.slice(0, 10)}` : "No PDF uploaded — buyers will see “being prepared”"}</p></div>
            {b.file ? <CheckCircle2 className="w-4 h-4 text-emerald-400" data-testid={`book-ready-${b.slug}`} /> : <span className="text-[10px] font-mono text-amber-300">MISSING</span>}
            <button onClick={() => pick(b.slug)} disabled={!!busy} className="h-8 px-3 rounded-md border border-slate-700 text-xs inline-flex items-center gap-1 hover:bg-slate-800" data-testid={`book-upload-${b.slug}`}>{busy === b.slug ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Upload className="w-3.5 h-3.5" />}{b.file ? "Replace" : "Upload PDF"}</button>
          </div>
        ))}
      </div>
    </div>
  );
}
